var request = require("request");

function returnPromise(options) {
  var isJsonRPC = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return new Promise(function (resolve, reject) {
    sendRequest(options, function (err, response) {
      if (err) return reject(err);
      if (isJsonRPC) return resolve(response.result);
      if (!isJsonRPC) return resolve(response);
    });
  });
}

function sendRequest(options, callback) {
  request(options, function (error, response, body) {
    if (error || response.body.error || response.statusCode !== 200) {
      callback(error || response.body.error || {
        statusCode: response.statusCode
      });
      return;
    }

    callback(null, body);
  });
}

module.exports = {
  returnPromise: returnPromise
};